import { get } from "./index";

export const getReviewsList = (params) => {
  const request = {
    subUrl: `/website/getAllReviews`,
    params,
  };
  return get(request);
};
